import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';

export const Modal = ({ open, onClose, children }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          overflow: 'visible',
        },
      }}
    >
      <DialogBody>{children}</DialogBody>
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

const DialogBody = styled.div`
  padding: 24px;
  border-radius: 8px;
`;
